import { useScrollTrigger } from '@material-ui/core';
import React from 'react';

interface IProps {
  children: React.ReactElement;
}

export default function ElevationScroll(props: IProps) {
  const { children } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    style: trigger
      ? { ...children.props.style, boxShadow: '0px 15px 10px -15px #CBCBCB' }
      : { ...children.props.style },
  });
}
